import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchLinkLabel: {
		id: 'dynamic-cards-search-page.search-link.label',
		defaultMessage: 'Search Link',
		description: 'Accessibility label for the search link component',
	},
});
